import { useMemo } from 'react';
import { Music24Capabilities } from 'fym-common/src/license/music24Plans';
import { music24NoCapabilities } from 'fym-common/src/license/music24NoLicense';
import { useLicenseInfo } from '../../../redux/slices/license/hooks/hooks';

/**
 * The signed-in artist's Music24 plan limits.
 *
 * The `license` redux slice is the source — the same object the trial pill reads for the plan name
 * — so a locked control and the trial banner never disagree. A licence saved before a field
 * existed can miss it, so every field falls back to the no-licence Free row first: the strictest
 * row, never a false unlock. That row also has AI Reels off, which the plan table has on (a
 * caller with no licence has no workspace for a reel).
 */
export function useMusic24Capabilities(): Music24Capabilities {
  const licenseInfo = useLicenseInfo();
  const smlCapabilities = licenseInfo.license?.smlCapabilities;
  // One object per licence change, so a reader can put it in a hook's dependency list.
  return useMemo(() => ({ ...music24NoCapabilities, ...smlCapabilities }), [smlCapabilities]);
}
